import * as Yup from 'yup';
import { ValidationRules } from 'helpers/createFormConfig';
import { mandantsArraySchema } from 'back-office/shared/components/mandants/mandantsValidation';
import { addressValidationRules } from 'features/new-actor/form/validation-rules/addressValidationRules';
import { MiaFormFieldNames } from './MiaFormFieldNames';
import { MiaFormValues } from './MiaFormValues';

import { gerantValidationRules, optionalCompanyPhoneRule } from 'back-office/shared/components/gerant/gerantFields';
export const miaValidationRules: ValidationRules<keyof MiaFormValues> = {
  ...gerantValidationRules,
  ...addressValidationRules,
  [MiaFormFieldNames.CompanyName]: Yup.string()
    .required('La raison sociale est requise')
    .min(2, 'La raison sociale doit contenir au moins 2 caractères'),
  [MiaFormFieldNames.Phone]: optionalCompanyPhoneRule,
  [MiaFormFieldNames.RegistrationNumber]: Yup.string()
    .required('Le numéro SIRET est requis')
    .matches(/^\d{14}$/, 'Le SIRET doit contenir 14 chiffres'),
  [MiaFormFieldNames.Capital]: Yup.number()
    .required('Le capital est requis')
    .min(0, 'Le capital doit être positif'),
  [MiaFormFieldNames.RcsCity]: Yup.string()
    .required('La ville RCS est requise'),
  [MiaFormFieldNames.RcsNumber]: Yup.string()
    .required('Le numéro RCS est requis'),
  // ORIAS obligatoire pour la nature MIA (mandataire immatriculé à l'ORIAS)
  [MiaFormFieldNames.OriasNumber]: Yup.string()
    .required('Le numéro ORIAS est requis pour un MIA'),
  [MiaFormFieldNames.Rcp]: Yup.string()
    .nullable()
    .notRequired(),
  [MiaFormFieldNames.ComplaintEmail]: Yup.string()
    .required("L'email de réclamation est requis")
    .email('Format email invalide'),
  [MiaFormFieldNames.Mandants]: mandantsArraySchema,
  [MiaFormFieldNames.FirstName]: Yup.string()
    .required('Le prénom est requis')
    .min(2, 'Le prénom doit contenir au moins 2 caractères'),
  [MiaFormFieldNames.LastName]: Yup.string()
    .required('Le nom est requis')
    .min(2, 'Le nom doit contenir au moins 2 caractères'),
  [MiaFormFieldNames.Email]: Yup.string()
    .required("L'email est requis")
    .email('Format email invalide'),
  [MiaFormFieldNames.Username]: Yup.string()
    .required("Le nom d'utilisateur est requis")
    .min(3, "Le nom d'utilisateur doit contenir au moins 3 caractères"),
  [MiaFormFieldNames.Password]: Yup.string()
    .required('Le mot de passe est requis')
    .min(8, 'Le mot de passe doit contenir au moins 8 caractères'),
  // Les plateformes d'abord : chaque mandant doit en partager au moins une.
  [MiaFormFieldNames.PlateformeIds]: Yup.array()
    .of(Yup.string().required())
    .min(1, 'Au moins une plateforme est requise')
    .required('Les plateformes sont requises'),
};
